import { useContext } from 'react';

import { ThemeContext } from './themeContextObject.js';

/**
 * Read and control the active colour theme.
 *
 * @returns {{
 *   theme: 'light' | 'dark',
 *   isDark: boolean,
 *   setTheme: (theme: 'light' | 'dark') => void,
 *   toggleTheme: () => void,
 * }}
 */
export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used inside a <ThemeProvider>');
  }
  return context;
}
